const dropContainer = {
  scheduledServiceTitle: 'Servicio programado',
  scheduledServicesTitle: 'Servicios programados',  
  scheduledServiceDoneTitle: 'Servicio completado',
  scheduledServicesDoneTitle: 'Servicios completados',
};

export default dropContainer;
